<template>
  <div class="card is-stock" :class="{ 'is-reserve': card.is_available, 'card--disabled': card.is_rented }">
    <card-slider :slides="photos" :link="'/ul/car/' + card.id"></card-slider>
    <router-link class="card__content" :to="'/ul/car/' + card.id">
      <div class="card__title">{{ card.make }} {{ card.version }}</div>
      <div class="card_content-wr">
        <div class="card__engine">{{ getVolume(card.engine_volume) }}л, {{ card.engine_horse_power }} л.с.</div>
        <div class="card__drivetrain">{{ card.driving_gear_type }} привод</div>
        <div class="card__consumption">{{ card.fuel_type }}</div>
        <div class="card__price">{{ formatPrice(Math.ceil(card.lease_month_price * 1.1 / 100) * 100) }}</div>
        <div class="card__statuses">
          <div v-if="card.is_available" class="card__status">В наличии</div>
          <div v-else class="card__status">В поставке</div>
          <div v-if="card.total_trip > 1000" class="card__status red">С пробегом</div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import CardSlider from './CardSlider';
export default {
  name: 'CardUl',
  components: {
    CardSlider
  },
  props: {
    card: {
      type: Object,
    },
    rclass: {
      type: Object,
    }
  },
  computed: {
    photos() {
      if (!this.card.photos?.length && this.rclass?.photos?.length) {
        return this.rclass.photos;
      }

      return this.card.photos;
    }
  },
  methods: {
    getVolume(num) {
      return Number((num * 0.001).toFixed(2));
    },
    formatPrice(price) {
      return price > 0 ? `${price.toLocaleString('ru-RU')}руб. ежемесячно` : 'Цена уточняется';
    },
  }
};
</script>